import React, { useState, useEffect } from "react";
import "../styles/cookiebanner.css";

function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
    // Ide kerülhet például a Google Analytics vagy más szolgáltatás aktiválása
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <p className="cookie-text">
        Ez a weboldal sütiket használ a legjobb élmény biztosítása érdekében.{" "}
        <a href="/privacy-policy" className="cookie-link">
          Adatvédelmi tájékoztató
        </a>
      </p>
      <div className="cookie-buttons">
        <button className="cookie-button accept" onClick={handleAccept}>
          Elfogadom
        </button>
        <button className="cookie-button decline" onClick={handleDecline}>
          Elutasítom
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
